// extracted by mini-css-extract-plugin
module.exports = {"options":"LocaleSwitcher_options__1QHJL","option":"LocaleSwitcher_option__1rNih","activeOption":"LocaleSwitcher_activeOption__40VCb LocaleSwitcher_option__1rNih"};